(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2671],{

/***/ 64355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _lodash = _interopRequireDefault(__webpack_require__(96486));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Joins together the text values contained in a PortableText object.
 *
 * @param {Array} blocks - Array of PortableText block objects to join.
 *
 * @returns {string} - The string contents of the PortableText.
 */
var portableTextToPlain = function portableTextToPlain() {
  var blocks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _lodash["default"])(blocks).map(function (block) {
    // if it's not a text block with children, return nothing
    // eslint-disable-next-line no-underscore-dangle
    if ((block === null || block === void 0 ? void 0 : block._type) !== 'block' || !(block !== null && block !== void 0 && block.children)) {
      return '';
    }
    // loop through the children spans, and join the
    // text strings
    return (0, _lodash["default"])(block === null || block === void 0 ? void 0 : block.children).map('text').join('');
  }).filter(function (text) {
    return !(0, _fp.isEmpty)(text);
  }).join('\n');
};
var _default = exports["default"] = portableTextToPlain;
module.exports = exports.default;

/***/ }),

/***/ 23257:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var apiToAlert = function apiToAlert(apiError) {
  return {
    analyticsLabel: apiError.response || "API returned ".concat(JSON.stringify(apiError)),
    children: apiError.explanation || 'Oh no!',
    heading: apiError.response || 'Something went wrong',
    level: apiError.level || 'danger'
  };
};
var _default = exports["default"] = apiToAlert;
module.exports = exports.default;

/***/ }),

/***/ 55105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const lodash_1 = __importDefault(__webpack_require__(96486));
const assert_1 = __importDefault(__webpack_require__(27596));
const constants_1 = __webpack_require__(13294);
const LISTED_PRODUCT_TYPE_PATHS = {
    combined: 'hospital-extras-bundle',
    extras: 'extras-cover',
    hospital: 'hospital-cover',
    package: 'hospital-extras-packages',
};
function getProductUrl(args) {
    const { errorUrl, productId, rawUrl } = args || { errorUrl: undefined, productId: undefined, rawUrl: undefined };
    (0, assert_1.default)(lodash_1.default.isString(rawUrl), 'rawUrl must be a string');
    (0, assert_1.default)(lodash_1.default.isString(productId), 'productId must be a string');
    (0, assert_1.default)(lodash_1.default.isString(errorUrl), 'errorUrl must be a string');
    const type = lodash_1.default.findKey(constants_1.PRODUCTS_BY_TYPE, (products) => lodash_1.default.includes(products, productId));
    const parentProductId = lodash_1.default.findKey(constants_1.PRODUCTS_BY_PARENT, (products) => lodash_1.default.includes(products, productId));
    if (lodash_1.default.isUndefined(type) || lodash_1.default.isUndefined(productId)) {
        return errorUrl;
    }
    const productUrl = (0, lodash_1.default)(rawUrl)
        .replace(':type', LISTED_PRODUCT_TYPE_PATHS[type])
        .replace(':id', parentProductId || lodash_1.default.replace(productId, /(\b-excess-)[0-9]*/, ''));
    return productUrl;
}
module.exports = {
    getProductUrl,
};


/***/ }),

/***/ 72487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ EXPLAINED_TERMS_SLUG_BLOCKLIST; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var EXPLAINED_TERMS_SLUG_BLOCKLIST = {
    EXTRAS_COVER_LANDING_PAGE: "extras-cover-ccs",
    HEALTH_INSURANCE_LANDING_PAGE: "health-insurance-ccs"
};
var isInExplainedBlocklist = function(slug) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(slug, EXPLAINED_TERMS_SLUG_BLOCKLIST);
};
/* harmony default export */ __webpack_exports__["Z"] = (isInExplainedBlocklist);


/***/ }),

/***/ 13535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71439);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28937);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment howToFields on HowTo {\n    id: _id\n    name\n    slogan: sloganRaw\n    steps {\n      name\n      description: descriptionRaw\n      ",
        "\n      ",
        "\n    }\n    ",
        "\n    importance\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__.gql)(_templateObject(), _constants__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL.IMAGE_OBJECT */ .gQ.IMAGE_OBJECT, _constants__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL.URL_OBJECT */ .gQ.URL_OBJECT, _constants__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL.URL_OBJECT */ .gQ.URL_OBJECT));


/***/ }),

/***/ 50739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_get_footnote_serializer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50073);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89990);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96852);









var mapWithIndex = (0,_utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(lodash_fp__WEBPACK_IMPORTED_MODULE_2__.map);
var amountOfColumns = 2;
var largeThreshold = "60rem";
var ContentTilesSection = function(param) {
    var contentTiles = param.contentTiles;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(contentTiles)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: mapWithIndex(function(tiles, index) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .BorderGridContainer */ .sO, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .AxisSwitcher */ .e$, {
                    limit: amountOfColumns,
                    threshold: largeThreshold,
                    children: mapWithIndex(function(tile, tileIndex) {
                        var footnote = tile === null || tile === void 0 ? void 0 : tile.footnote;
                        var formattedCtas = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.map)(function(cta) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, cta), {
                                link: cta.url,
                                linkText: cta.name
                            });
                        }, tile.ctas);
                        var formattedTile = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, tile), {
                            ctas: formattedCtas
                        });
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
                            padding: "1rem",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .ContentTile */ .Jm, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, formattedTile), {
                                customSerializers: footnote ? (0,_utils_get_footnote_serializer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                                    footnote: footnote,
                                    variant: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_8___default().footnote)
                                }) : {}
                            }))
                        }, tileIndex);
                    }, tiles)
                })
            }, index);
        }, contentTiles)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentTilesSection);


/***/ }),

/***/ 85878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96852);





var mapWithIndex = (0,_utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(lodash_fp__WEBPACK_IMPORTED_MODULE_1__.map);
var PageSections = function(param) {
    var components = param.components, content = param.content;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'sections' does not exist on type 'ExplainedTerm'.
    var sections = content === null || content === void 0 ? void 0 : content.sections;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: mapWithIndex(function(section, index) {
            var Component = components[section.type];
            if (!Component) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, section), index);
        }, sections)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageSections);


/***/ }),

/***/ 24699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ get_content_tiles_data; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/client/cms/constants/index.ts
var constants = __webpack_require__(28937);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/cms/utils/get-image-attributes/index.ts
var get_image_attributes = __webpack_require__(51413);
;// CONCATENATED MODULE: ./src/client/pages/explained-term/detail/utils/format-data-for-content-tile/index.ts







var _URLS = ahm_constants/* default.URLS */.Z.URLS, EXPLAINED = _URLS.SALES.EXPLAINED;
var formatDataForContentTile = function(param) {
    var _explainedTermTiles = param.explainedTermTiles, explainedTermTiles = _explainedTermTiles === void 0 ? [] : _explainedTermTiles, _serviceTiles = param.serviceTiles, serviceTiles = _serviceTiles === void 0 ? [] : _serviceTiles;
    var combinedData = (0,fp.compact)((0,_to_consumable_array/* default */.Z)(explainedTermTiles).concat((0,_to_consumable_array/* default */.Z)(serviceTiles)));
    if ((0,fp.isEmpty)(combinedData)) {
        return [];
    }
    return (0,fp.map)(function(tileData) {
        var identifier = tileData.identifier, imageObject = tileData.imageObject, slogan = tileData.slogan, summary = tileData.summary, urlObject = tileData.urlObject, __typename = tileData.__typename;
        var sharedFields = {
            image: (0,get_image_attributes/* default */.Z)({
                height: 240,
                imageObject: imageObject
            }),
            subtitle: summary,
            title: slogan
        };
        return __typename === constants/* CONTENT_TYPE.SERVICE */.zv.SERVICE ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedFields), {
            ctas: [
                {
                    name: urlObject === null || urlObject === void 0 ? void 0 : urlObject.name,
                    url: urlObject === null || urlObject === void 0 ? void 0 : urlObject.url
                }
            ]
        }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedFields), {
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'detailsTeaser' does not exist on type 'CustomService | CustomExplainedTerm'.
            ctas: [
                {
                    name: tileData === null || tileData === void 0 ? void 0 : tileData.detailsTeaser,
                    url: "".concat(EXPLAINED, "/").concat(identifier === null || identifier === void 0 ? void 0 : identifier.current)
                }
            ]
        });
    }, combinedData);
};
/* harmony default export */ var format_data_for_content_tile = (formatDataForContentTile);

;// CONCATENATED MODULE: ./src/client/pages/explained-term/detail/utils/get-content-tiles-data/index.ts





var FULL_WIDTH = ui.TILE_VARIANTS.FULL_WIDTH, HORIZONTAL = ui.TILE_VARIANTS.HORIZONTAL, VERTICAL_CENTER = ui.TILE_VARIANTS.VERTICAL_CENTER;
// @ts-expect-error - Automatic, Please fix when editing this file
var groupRowDataByVariant = function(param) {
    var amountOfCenteredRows = param.amountOfCenteredRows, amountOfLeftAlignedRows = param.amountOfLeftAlignedRows, chunksOfTiles = param.chunksOfTiles;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    fp.map.convert({
        cap: false
    })(function(tileChunk, index) {
        var rowNumber = index + 1;
        var totalHalfTiles = amountOfLeftAlignedRows + amountOfCenteredRows;
        var halfLeftAlignedType = rowNumber <= amountOfLeftAlignedRows ? HORIZONTAL : null;
        var halfCenterAlignedType = rowNumber > amountOfLeftAlignedRows && rowNumber <= totalHalfTiles ? VERTICAL_CENTER : null;
        var variantType = halfLeftAlignedType || halfCenterAlignedType || FULL_WIDTH;
        // @ts-expect-error - Automatic, Please fix when editing this file
        return (0,fp.map)(function(tileData) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tileData), {
                variant: variantType
            });
        })(tileChunk);
    })(chunksOfTiles));
};
/**
 * This function takes in mediumImportanceChildTerms and marketingOrSalesCTA objects, combines and formats the data to render out content tile components.
 * Depending on the row number, the variant for each particular row will change. The rows will be split into two, and if there is an uneven amount of rows the extra row
 * will be set to be the left aligned variant, unless its a single row (of two tiles). If there is an uneven amount of tiles the last row will be full width.
 *
 * @param {object} param - An object.
 * @param {Array.<object>} param.explainedTermTiles - ExplainedTermTiles - An array of explained terms.
 * @param {Array.<object>} param.serviceTiles - ServiceTiles - An array of service items.
 * @returns {Array.<object>} An array of objects. Each object contains the row number and the tile data to render for the row.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var getContentTilesData = function(param) {
    var explainedTermTiles = param.explainedTermTiles, serviceTiles = param.serviceTiles;
    var formattedTileData = format_data_for_content_tile({
        explainedTermTiles: explainedTermTiles,
        serviceTiles: serviceTiles
    });
    var isEvenAmountOfTiles = formattedTileData.length % 2 === 0;
    var chunksOfTiles = (0,fp.chunk)(2, formattedTileData);
    // subtract a row if uneven amount of tiles, so the last row is full width variant
    var rowsAmount = isEvenAmountOfTiles ? (0,fp.size)(chunksOfTiles) : (0,fp.size)(chunksOfTiles) - 1;
    var unevenAmountOfRows = rowsAmount % 2;
    // to get an even amount when halving an uneven amount, remove the uneven amount of rows
    var halfRowsAmount = (rowsAmount - unevenAmountOfRows) / 2;
    var leftAlignedAmount = unevenAmountOfRows ? halfRowsAmount + 1 : halfRowsAmount;
    var hasSingleCenterAlignedRow = rowsAmount === 1;
    return groupRowDataByVariant({
        amountOfCenteredRows: hasSingleCenterAlignedRow ? 1 : halfRowsAmount,
        amountOfLeftAlignedRows: hasSingleCenterAlignedRow ? 0 : leftAlignedAmount,
        chunksOfTiles: chunksOfTiles
    });
};
/* harmony default export */ var get_content_tiles_data = (getContentTilesData);


/***/ }),

/***/ 12349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_get_explained_term; }
});

// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var client = __webpack_require__(46829);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
// EXTERNAL MODULE: ./src/client/cms/constants/index.ts
var constants = __webpack_require__(28937);
;// CONCATENATED MODULE: ./src/client/cms/fragments/award-fields/index.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment awardFields on Award {\n    name\n    summary: summaryRaw\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var award_fields = ((0,core.gql)(_templateObject(), constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT, constants/* GRAPHQL.SLUG */.gQ.SLUG));

;// CONCATENATED MODULE: ./src/client/cms/fragments/common-questions-fields/index.ts

function common_questions_fields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment commonQuestionsFields on CommonQuestions {\n        title\n        summary: summaryRaw\n        ",
        "\n        questions {\n          question\n          answerRaw\n        }\n    }\n"
    ]);
    common_questions_fields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var common_questions_fields = ((0,core.gql)(common_questions_fields_templateObject(), constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT));

;// CONCATENATED MODULE: ./src/client/cms/fragments/explained-term-fields/index.ts

function explained_term_fields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment explainedTermFields on ExplainedTerm {\n    __typename\n    detailsTeaser\n    id: _id\n    marketingOrSalesCTA {\n      description: descriptionRaw\n      name\n      slogan: sloganRaw\n      summary: summaryRaw\n      ",
        "\n      ",
        "\n      ",
        "\n    }\n    name\n    slogan: sloganRaw\n    summary: summaryRaw\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    explained_term_fields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var explainedTermFields = (0,core.gql)(explained_term_fields_templateObject(), constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT, constants/* GRAPHQL.SLUG */.gQ.SLUG, constants/* GRAPHQL.URL_OBJECT */.gQ.URL_OBJECT, constants/* GRAPHQL.SLUG */.gQ.SLUG, constants/* GRAPHQL.URL_OBJECT */.gQ.URL_OBJECT, constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT);
/* harmony default export */ var explained_term_fields = (explainedTermFields);

// EXTERNAL MODULE: ./src/client/cms/fragments/how-to-fields/index.ts
var how_to_fields = __webpack_require__(13535);
;// CONCATENATED MODULE: ./src/client/cms/fragments/product-list-fields/index.ts

function product_list_fields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment productListFields on ProductList {\n        title\n        productIds\n        ",
        "\n    }\n"
    ]);
    product_list_fields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var product_list_fields = ((0,core.gql)(product_list_fields_templateObject(), constants/* GRAPHQL.URL_OBJECT */.gQ.URL_OBJECT));

;// CONCATENATED MODULE: ./src/client/cms/fragments/selling-point-fields/index.ts

function selling_point_fields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment sellingPointFields on SellingPointGroup {\n    name\n    slogan: sloganRaw\n    summary: summaryRaw\n    sellingPointGroup {\n      name\n      summary: summaryRaw\n    }\n    cta: ",
        "\n  }\n"
    ]);
    selling_point_fields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var selling_point_fields = ((0,core.gql)(selling_point_fields_templateObject(), constants/* GRAPHQL.URL_OBJECT */.gQ.URL_OBJECT));

;// CONCATENATED MODULE: ./src/client/cms/fragments/topic-group-fields/index.ts

function topic_group_fields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment topicGroupFields on TopicGroup {\n        name\n        slogan: sloganRaw\n        summary: summaryRaw\n        topicGroup {\n          id: _id\n          name\n          slogan: sloganRaw\n          mediaObject {\n            description: descriptionRaw\n            ",
        "\n          }\n          ",
        "\n        }\n    }\n"
    ]);
    topic_group_fields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var topic_group_fields = ((0,core.gql)(topic_group_fields_templateObject(), constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT, constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT));

;// CONCATENATED MODULE: ./src/client/cms/fragments/value-proposition-fields/index.ts

function value_proposition_fields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment valuePropositionFields on ValueProposition {\n    name\n    slogan: sloganRaw\n    summary: summaryRaw\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    value_proposition_fields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var value_proposition_fields = ((0,core.gql)(value_proposition_fields_templateObject(), constants/* GRAPHQL.URL_OBJECT */.gQ.URL_OBJECT, constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT));

;// CONCATENATED MODULE: ./src/client/pages/explained-term/detail/queries/get-explained-term/index.ts

function get_explained_term_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getExplainedTerm($slug: String) {\n    allExplainedTerm(\n      where: { identifier: { current: { eq: $slug } } }\n    ) {\n      ...explainedTermFields\n      metadataObject {\n        name\n        descriptionRaw\n      }\n      refersToContent {\n        ... on ProductList {\n          ...productListFields\n        }\n        ... on Award {\n          ...awardFields\n        }\n        ... on HowTo {\n          ...howToFields\n        }\n        ... on ValuePropositionsObject {\n          title\n          valuePropositionsReference {\n            ...valuePropositionFields\n          }\n          ",
        "\n        }\n        ... on CommonQuestions {\n          ...commonQuestionsFields\n        }\n        ... on RelatedTopicsUrl {\n          ",
        "\n        }\n        ... on SellingPointGroup {\n          ...sellingPointFields\n        }\n        ... on TopicGroup {\n          ...topicGroupFields\n        }\n        ... on ContentTiles {\n          tiles {\n            ... on ExplainedTerm {\n              ...explainedTermFields\n              ",
        "\n            }\n            ... on Service {\n              ",
        "\n              ",
        "\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    get_explained_term_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










// eslint-disable-next-line import/prefer-default-export
var GET_EXPLAINED_TERM = (0,core.gql)(get_explained_term_templateObject(), constants/* GRAPHQL.URL_OBJECT */.gQ.URL_OBJECT, constants/* GRAPHQL.URL_OBJECTS */.gQ.URL_OBJECTS, constants/* GRAPHQL.CONTENT_TILE_FIELDS */.gQ.CONTENT_TILE_FIELDS, constants/* GRAPHQL.CONTENT_TILE_FIELDS */.gQ.CONTENT_TILE_FIELDS, constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT, award_fields, common_questions_fields, explained_term_fields, how_to_fields/* default */.Z, selling_point_fields, topic_group_fields, value_proposition_fields, product_list_fields);
/* harmony default export */ var get_explained_term = (GET_EXPLAINED_TERM);

// EXTERNAL MODULE: ./src/client/cms/utils/unique-content-with-draft-precedence/index.ts
var unique_content_with_draft_precedence = __webpack_require__(92002);
;// CONCATENATED MODULE: ./src/client/pages/explained-term/detail/utils/use-get-explained-term/index.ts




var useGetExplainedTerm = function(param) {
    var _skip = param.skip, skip = _skip === void 0 ? false : _skip, slug = param.slug;
    var ref = (0,client.useQuery)(get_explained_term, {
        skip: skip,
        variables: {
            slug: slug
        }
    }), called = ref.called, data = ref.data, loading = ref.loading, error = ref.error;
    return {
        error: error,
        explainedTerm: (0,fp.head)((0,unique_content_with_draft_precedence/* default */.Z)(data === null || data === void 0 ? void 0 : data.allExplainedTerm)),
        hasErrors: Boolean(error),
        isLoading: !called || loading
    };
};
/* harmony default export */ var use_get_explained_term = (useGetExplainedTerm);


/***/ }),

/***/ 89990:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","footnote":"styles_footnote__eXfNE"};

/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 88029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ })

}]);